import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const EanIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 67 67">
      <path
        id="Path_149"
        data-name="Path 149"
        d="M1.963,14.395a1.963,1.963,0,0,0,1.963-1.963V3.926h8.506a1.963,1.963,0,1,0,0-3.926H1.963A1.963,1.963,0,0,0,0,1.963V12.432A1.963,1.963,0,0,0,1.963,14.395Z"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_150"
        data-name="Path 150"
        d="M414.432,0H403.963a1.963,1.963,0,1,0,0,3.926h8.506v8.506a1.963,1.963,0,0,0,3.926,0V1.963A1.963,1.963,0,0,0,414.432,0Z"
        transform="translate(-349.395)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_151"
        data-name="Path 151"
        d="M12.432,412.469H3.926v-8.506a1.963,1.963,0,1,0-3.926,0v10.469a1.963,1.963,0,0,0,1.963,1.963H12.432a1.963,1.963,0,0,0,0-3.926Z"
        transform="translate(0 -349.395)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_152"
        data-name="Path 152"
        d="M414.432,402a1.963,1.963,0,0,0-1.963,1.963v8.506h-8.506a1.963,1.963,0,0,0,0,3.926h10.469a1.963,1.963,0,0,0,1.963-1.963V403.963A1.963,1.963,0,0,0,414.432,402Z"
        transform="translate(-349.395 -349.395)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_157"
        data-name="Path 157"
        d="M242.963,111.786a1.955,1.955,0,0,0,1.963-1.947V62.947a1.963,1.963,0,0,0-3.926,0v46.892A1.955,1.955,0,0,0,242.963,111.786Z"
        transform="translate(-208.5 -52.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_324"
        data-name="Path 324"
        d="M242.963,111.786a1.955,1.955,0,0,0,1.963-1.947V62.947a1.963,1.963,0,0,0-3.926,0v46.892A1.955,1.955,0,0,0,242.963,111.786Z"
        transform="translate(-216.499 -52.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_320"
        data-name="Path 320"
        d="M242.963,111.786a1.955,1.955,0,0,0,1.963-1.947V62.947a1.963,1.963,0,0,0-3.926,0v46.892A1.955,1.955,0,0,0,242.963,111.786Z"
        transform="translate(-232.5 -52.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_161"
        data-name="Path 161"
        d="M301,302.963v36.713a1.963,1.963,0,0,0,3.926,0V302.963a1.963,1.963,0,1,0-3.926,0Z"
        transform="translate(-261.501 -292.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_321"
        data-name="Path 321"
        d="M242.963,111.786a1.955,1.955,0,0,0,1.963-1.947V62.947a1.963,1.963,0,0,0-3.926,0v46.892A1.955,1.955,0,0,0,242.963,111.786Z"
        transform="translate(-185.5 -52.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_322"
        data-name="Path 322"
        d="M301,302.963v36.713a1.963,1.963,0,0,0,3.926,0V302.963a1.963,1.963,0,1,0-3.926,0Z"
        transform="translate(-253.499 -292.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_323"
        data-name="Path 323"
        d="M301,302.963v36.713a1.963,1.963,0,0,0,3.926,0V302.963a1.963,1.963,0,1,0-3.926,0Z"
        transform="translate(-284.501 -292.611)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
    </SvgIcon>
  );
};
